__turbopack_context__.v({
  "chips": "FilterChips-module-scss-module__ueoFeW__chips",
  "item": "FilterChips-module-scss-module__ueoFeW__item",
  "list": "FilterChips-module-scss-module__ueoFeW__list",
});
